// extracted by mini-css-extract-plugin
export default {"input":"input_text-module__input--28_Q-","label":"input_text-module__label--RXqvz"};